import * as React from "react"
import { Chip } from "@mui/material"

const LABELS = {
    new: 'New',
    update: 'Modified',
    delete: 'To delete'
}

/** Marks a row the admin has touched but nobody has stored. */
export default function ManagementPricingConfigPendingChip({ pending }) {

    if (!pending) return <></>

    return <Chip
        size="small"
        variant="outlined"
        color={pending === 'delete' ? 'error' : 'warning'}
        label={LABELS[pending]}
        sx={{ ml: 1 }}
    />
}
